/* Colágeno: galería, botones que abren EasySell (con sus colores propios), slider antes/después y pestañas de preguntas. */
(function () {
  'use strict';
  if (window.__cgv) return;
  window.__cgv = true;

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function galeria() {
    $$('[data-cgv-gal]').forEach(function (gal) {
      var main = gal.querySelector('.cgv-gal-main');
      var thumbs = $$('.cgv-gal-thumbs button', gal);
      function marcar() {
        var i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
        thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t, j) {
        t.addEventListener('click', function () { main.scrollTo({ left: j * main.clientWidth, behavior: 'smooth' }); });
      });
      main.addEventListener('scroll', marcar, { passive: true });
      marcar();
    });
  }

  /* Los botones de las secciones abren el mismo formulario de pago al recibir que el buy-box */
  function comprar() {
    var es = document.querySelector('#cgv-buybox .es-popup-button') || document.querySelector('.es-popup-button') || document.querySelector('#es-sticky');
    if (es) { es.click(); return; }
    var btn = document.querySelector('#cgv-buybox [type="submit"]');
    if (btn) { btn.click(); return; }
    var box = document.getElementById('cgv-buybox');
    if (box) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function antesDespues() {
    $$('[data-cgv-ba]').forEach(function (ba) {
      var r = ba.querySelector('input[type=range]');
      function mover() { ba.style.setProperty('--pos', r.value + '%'); }
      r.addEventListener('input', mover);
      mover();
    });
  }

  function pestanas() {
    $$('[data-cgv-tabs]').forEach(function (w) {
      var tabs = $$('[role=tab]', w);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t;
            o.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = document.getElementById(o.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
      });
    });
  }

  function iniciar() {
    galeria();
    antesDespues();
    pestanas();
    $$('[data-cgv-cta]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); comprar(); }); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
